import { ArrowUpRight } from "lucide-react";

import { Link } from "@/i18n/navigation";

// Chip row inside a deck card's glass panel. Two kinds of chip, deliberately
// told apart at a glance:
//
//   badges — Flagship / the project's tier. These are the only *navigational*
//            chips: each one opens /portfolio already filtered or scrolled to
//            the matching set. Sky-blue outline + arrow so they read as links.
//   tags   — plain descriptive copy ("E-Commerce", "Full Revamp"). Faint glass,
//            no affordance, nothing to click.
//
// Labels arrive pre-translated from the server component; this stays purely
// presentational so it can live inside either client-side deck.
export default function ProjectChips({ badges = [], tags = [] }) {
  if (badges.length === 0 && tags.length === 0) return null;

  return (
    <div className="mt-5 flex flex-wrap items-center gap-2">
      {badges.map((badge) => (
        <Link
          key={badge.key}
          href={badge.href}
          className="group inline-flex items-center gap-1 rounded-full border border-sky-blue/70 py-1.5 pl-3.5 pr-2.5 text-base font-medium text-white transition-colors hover:border-sky-blue hover:bg-sky-blue/20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-blue"
        >
          {badge.label}
          <ArrowUpRight
            aria-hidden="true"
            className="h-[18px] w-[18px] transition-transform group-hover:-translate-y-px group-hover:translate-x-px"
          />
        </Link>
      ))}

      {badges.length > 0 && tags.length > 0 && (
        <span aria-hidden="true" className="mx-1 h-5 w-px bg-white/25" />
      )}

      {tags.map((tag) => (
        <span
          key={tag}
          className="rounded-full border border-white/35 px-3.5 py-1.5 text-base text-white/75"
        >
          {tag}
        </span>
      ))}
    </div>
  );
}
